export const SERVICE_LINKS = [
  { slug: "google-ads-management", title: "Google Ads Management", short: "Attract customers actively searching for your products and services.", icon: "Search", priceName: "Google Ads (PPC) Management" },
  { slug: "facebook-instagram-ads", title: "Facebook & Instagram Ads", short: "Reach new audiences, generate leads and increase sales through strategic Meta advertising.", icon: "Megaphone", priceName: "Facebook & Instagram Ads Management" },
  { slug: "seo", title: "SEO, GEO & AI Search", short: "Improve your visibility in Google search and AI-powered search tools like ChatGPT.", icon: "TrendingUp", priceName: "Search Engine Optimisation (SEO)" },
  { slug: "google-business-profile", title: "Google Business Profile", short: "Help local customers discover your business through Google Search and Maps.", icon: "MapPin", priceName: "Google Business Profile (Google Maps)" },
  { slug: "website-design-development", title: "Website Design & Development", short: "Beautiful, functional websites built around your customers.", icon: "MonitorSmartphone", priceName: "Website Design & Development" },
  { slug: "analytics-tracking-cro", title: "Analytics & Conversion Tracking", short: "Understand marketing performance through accurate GA4, GTM and conversion tracking.", icon: "BarChart3", priceName: "Google Analytics & Conversion Tracking Setup" },
  { slug: "analytics-tracking-cro", title: "Conversion Rate Optimisation", short: "Improve landing pages and turn more website visitors into enquiries.", icon: "MousePointerClick", anchor: "cro", priceName: "Conversion Rate Optimisation (CRO)" },
  { slug: "digital-marketing-audits", title: "Digital Marketing Audits", short: "Discover wasted spend, tracking problems and missed opportunities.", icon: "Stethoscope", priceName: "Digital Marketing Audit & Strategy" },
];

export const EXTRA_PRICES = ["Website Hosting & Maintenance", "Google Ads Audit", "SEO Audit"];

export const NAV_SERVICES = [
  ["google-ads-management", "Google Ads Management"],
  ["facebook-instagram-ads", "Facebook & Instagram Ads"],
  ["seo", "SEO, GEO & AI Search"],
  ["seo-backlinks-link-building", "SEO Backlinks & Link Building"],
  ["google-business-profile", "Google Business Profile"],
  ["website-design-development", "Website Design & Development"],
  ["website-hosting", "Website Hosting"],
  ["domain-registration", "Domain Registration & Management"],
  ["analytics-tracking-cro", "Analytics, Tracking & CRO"],
  ["digital-marketing-audits", "Digital Marketing Audits"],
];

export const NAV_MAIN = [
  ["/pricing", "Pricing"],
  ["/about-freya-jones", "About Freya"],
  ["/blog", "Blog"],
  ["/contact", "Contact"],
];

export const SERVICE_OPTIONS = [
  "Google Ads", "Facebook & Instagram Ads", "SEO", "Google Business Profile",
  "Website Design & Development", "Analytics & Tracking", "Conversion Rate Optimisation", "Digital Marketing Audit",
];

export const BUDGETS = ["Not currently advertising", "Under £500 / month", "£500 – £1,500 / month", "£1,500 – £5,000 / month", "£5,000+ / month", "Prefer not to say"];

export const AREAS = ["Kent", "East Sussex", "West Sussex", "Surrey", "London", "UK-wide"];
